module.exports = __webpack_public_path__ + "static/media/fleet.c43b57cc.svg";